(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-categories-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.nvrReady === '1' || root.dataset.nvrSlider !== 'true') return;
    var track = root.querySelector('[data-nvr-track]');
    if (!track) return;
    root.dataset.nvrReady = '1';

    var dotsWrap = root.querySelector('[data-nvr-dots]');
    var prev = root.querySelector('[data-nvr-prev]');
    var next = root.querySelector('[data-nvr-next]');
    var cards = Array.prototype.slice.call(track.children);
    var dots = [];
    var ticking = false;

    function isSlider() {
      return window.matchMedia('(max-width: 1024px)').matches;
    }
    function step() {
      var c = cards[0];
      if (!c) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return c.getBoundingClientRect().width + gap;
    }
    function visible() {
      var c = cards[0];
      if (!c) return 1;
      return Math.max(1, Math.round(track.clientWidth / c.getBoundingClientRect().width));
    }
    function pageCount() {
      return Math.max(1, cards.length - visible() + 1);
    }
    function current() {
      var s = step();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }
    function goTo(i) {
      var max = pageCount() - 1;
      i = Math.max(0, Math.min(max, i));
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    function buildDots() {
      if (!dotsWrap) return;
      var n = pageCount();
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cust-nvr__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          b.addEventListener('click', function () { goTo(idx); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
    }
    function update() {
      ticking = false;
      if (!isSlider()) return;
      var i = current();
      var max = pageCount() - 1;
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) i = max;
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= max;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    track.addEventListener('scroll', onScroll, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { buildDots(); update(); }, 150);
    });

    buildDots();
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.cust-nvr[data-nvr-slider="true"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-home-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.nvsReady) return;
    root.dataset.nvsReady = '1';
    var slides = [].slice.call(root.querySelectorAll('[data-nvs-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-nvs-dot]'));
    var pauseBtn = root.querySelector('[data-nvs-pause]');
    var modal = root.querySelector('[data-nvs-modal]');
    var frame = modal && modal.querySelector('.nvs__modal-frame');
    var delay = parseInt(root.dataset.delay, 10) || 5000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !reduce && slides.length > 1;
    var current = 0, timer = null, userPaused = false;

    function show(n) {
      current = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === current;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (autoplay && !userPaused) timer = setInterval(function () { show(current + 1); }, delay);
    }

    var prev = root.querySelector('[data-nvs-prev]');
    var next = root.querySelector('[data-nvs-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
    if (next) next.addEventListener('click', function () { show(current + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(+d.dataset.nvsDot); start(); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      userPaused = !userPaused;
      pauseBtn.setAttribute('aria-pressed', userPaused);
      pauseBtn.setAttribute('aria-label', userPaused ? 'Resume autoplay' : 'Pause autoplay');
      start();
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(current - 1); start(); }
      if (e.key === 'ArrowRight') { show(current + 1); start(); }
    });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { show(current + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });

    root.querySelectorAll('[data-nvs-video]').forEach(function (b) {
      b.addEventListener('click', function () {
        var tpl = b.parentNode.querySelector('[data-nvs-video-tpl]');
        if (!tpl || !frame) return;
        stop();
        frame.innerHTML = '';
        frame.appendChild(tpl.content.cloneNode(true));
        modal.showModal();
        var v = frame.querySelector('video');
        if (v) {
          v.muted = false;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    });
    if (modal) {
      var closeModal = function () { frame.innerHTML = ''; start(); };
      modal.addEventListener('close', closeModal);
      modal.querySelector('[data-nvs-close]').addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    root.addEventListener('shopify:block:select', function (e) {
      var i = slides.findIndex(function (s) { return s.dataset.blockId === e.detail.blockId; });
      if (i > -1) { autoplay = false; stop(); show(i); }
    });

    start();
  }

  function boot() { document.querySelectorAll('[data-nvs]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-performance-compare"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    if (!root || root.__psiInit) return;
    root.__psiInit = true;
    var track = root.querySelector('[data-psi-track]');
    var dots = root.querySelectorAll('[data-psi-dot]');
    if (!track || !dots.length) return;
    var items = track.children;
    var ticking = false;

    function setActive(i) {
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
      }
    }

    function update() {
      ticking = false;
      var left = track.getBoundingClientRect().left;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var dist = Math.abs(items[i].getBoundingClientRect().left - left - parseFloat(getComputedStyle(track).paddingLeft || 0));
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      // at the very end of the scroll, force the last dot
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = items.length - 1;
      setActive(best);
    }

    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          var item = items[idx];
          if (!item) return;
          var pad = parseFloat(getComputedStyle(track).paddingLeft || 0);
          track.scrollTo({ left: item.offsetLeft - pad, behavior: 'smooth' });
        });
      })(d);
    }
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-psi-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
